var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import * as Prismic from 'prismic-javascript';
import * as qs from 'qs';
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { data: undefined, id: undefined };
        _this.fetch = function (_a) {
            var api = _a.api, location = _a.location, fetchData = _a.fetchData;
            return __awaiter(_this, void 0, void 0, function () {
                var id, data;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            id = location.hash.substr(1);
                            return [4 /*yield*/, fetchData(api)];
                        case 1:
                            data = _b.sent();
                            this.setState({ id: id, data: data });
                            return [2 /*return*/];
                    }
                });
            });
        };
        return _this;
    }
    Item.prototype.componentDidMount = function () {
        this.fetch(this.props);
    };
    Item.prototype.render = function () {
        var _a = this.state, id = _a.id, data = _a.data;
        var render = this.props.render;
        return render(data, id);
    };
    return Item;
}(React.Component));
var Redirect = /** @class */ (function (_super) {
    __extends(Redirect, _super);
    function Redirect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { doc: null };
        return _this;
    }
    Redirect.prototype.componentDidMount = function () {
        var _a = this.props, api = _a.api, history = _a.history, location = _a.location;
        var _b = qs.parse(location.search.slice(1)), token = _b.token, documentId = _b.documentId;
        if (token) {
            api.previewSession(token, function () { return '/'; }, '/').then(function () {
                history.push("/preview#" + documentId);
            });
            // props.history.push(`${url}?preview=true`);
        }
    };
    Redirect.prototype.render = function () {
        return null;
    };
    return Redirect;
}(React.Component));
var Preview = /** @class */ (function (_super) {
    __extends(Preview, _super);
    function Preview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { api: undefined };
        return _this;
    }
    Preview.prototype.componentDidMount = function () {
        var _this = this;
        var name = this.props.name;
        window['prismic'] = {
            endpoint: "https://" + name + ".prismic.io/api/v2"
        };
        Prismic.getApi("https://" + name + ".prismic.io/api/v2").then(function (api) {
            return _this.setState({ api: api });
        });
    };
    Preview.prototype.render = function () {
        var api = this.state.api;
        var _a = this.props, render = _a.render, fetchData = _a.fetchData, head = _a.head, history = _a.history, location = _a.location;
        return (React.createElement(React.Fragment, null,
            head(React.createElement("script", { type: "text/javascript", src: "//static.cdn.prismic.io/prismic.min.js" })),
            api && React.createElement(Redirect, { location: location, history: history, api: api }),
            api && (React.createElement(Item, { location: location, api: api, fetchData: fetchData, render: render }))));
    };
    return Preview;
}(React.Component));
export default Preview;
//# sourceMappingURL=preview.js.map